// ....................................................................................
// ......SSSSSSSSS......TTTTTTTTTTTTTTTTTTT......OOOOOOOOOO........PPPPPPPPPPPP........
// ....SSSSSSSSSSSSS...STTTTTTTTTTTTTTTTTTT....OOOOOOOOOOOOO......PPPPPPPPPPPPPPPP.....
// ...SSSSSSSSSSSSSSS..STTTTTTTTTTTTTTTTTTT...OOOOOOOOOOOOOOOO....PPPPPPPPPPPPPPPPP....
// ...SSSSSSSSSSSSSSSS.STTTTTTTTTTTTTTTTTTT..OOOOOOOOOOOOOOOOOO...PPPPPPPPPPPPPPPPPP...
// ..SSSSSSSSSSSSSSSSSSSTTTTTTTTTTTTTTTTTTT.OOOOOOOOOOOOOOOOOOO...PPPPPPPPPPPPPPPPPP...
// ..SSSSSSS....SSSSSSS.TTTTTTTTTTTTTTTTTTTOOOOOOOOO...OOOOOOOOO..PPPPPPPPPPPPPPPPPPP..
// ..SSSSSS......SSSSSS.......TTTTTTT......OOOOOOO.......OOOOOOO..PPPPPPP.....PPPPPPP..
// ..SSSSSS......SSSSSS.......TTTTTTT......OOOOOOO.......OOOOOOOO.PPPPPPP.....PPPPPPP..
// ..SSSSSSSS.................TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPP.....PPPPPPP..
// ..SSSSSSSSSSSS.............TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPP.....PPPPPPP..
// ..SSSSSSSSSSSSSSS..........TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPPPPPPPPPPPPPP..
// ...SSSSSSSSSSSSSSSS........TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPPPPPPPPPPPPPP..
// ....SSSSSSSSSSSSSSSS.......TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPPPPPPPPPPPPP...
// ......SSSSSSSSSSSSSSS......TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPPPPPPPPPPPP....
// ..........SSSSSSSSSSS......TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPPPPPPPPPPP.....
// ..SSSSS.......SSSSSSS......TTTTTTT......OOOOOO.........OOOOOOO.PPPPPPPPPPPPPP.......
// .SSSSSSS.......SSSSSS......TTTTTTT......OOOOOOO.......OOOOOOOO.PPPPPPP..............
// .SSSSSSS......SSSSSSS......TTTTTTT......OOOOOOOO.....OOOOOOOO..PPPPPPP..............
// .SSSSSSSS....SSSSSSSS......TTTTTTT.......OOOOOOOO...OOOOOOOOO..PPPPPPP..............
// ..SSSSSSSSSSSSSSSSSS.......TTTTTTT.......OOOOOOOOOOOOOOOOOOO...PPPPPPP..............
// ...SSSSSSSSSSSSSSSSS.......TTTTTTT........OOOOOOOOOOOOOOOOO....PPPPPPP..............
// ...SSSSSSSSSSSSSSSS........TTTTTTT.........OOOOOOOOOOOOOOO.....PPPPPPP..............
// .....SSSSSSSSSSSSS.........TTTTTTT..........OOOOOOOOOOOOO......PPPPPPP..............
// .......SSSSSSSSS..............................OOOOOOOOO.............................
// ....................................................................................
/** @deprecated Do not use this enum. Use hardcoded IDs instead */
export var PageComponentId;
(function (PageComponentId) {
    PageComponentId["Challenges"] = "challenges-web-business-manager";
    PageComponentId["Home"] = "home";
    PageComponentId["BusinessOverview"] = "business-overview";
    PageComponentId["Settings"] = "settings-lazy-module";
    PageComponentId["SiteSettings"] = "site-settings-lazy-module";
    PageComponentId["DeprecatedSiteSettings"] = "site-settings-lazy-module-old";
    PageComponentId["Gdpr"] = "gdpr-users-client-page-component";
    PageComponentId["Engage"] = "engage";
    PageComponentId["InboxSettings"] = "inbox-settings";
    PageComponentId["ChatDashboard"] = "chat-dashboard";
    PageComponentId["ChatDashboardInstallationEntry"] = "chat-dashboard-installation-entry";
    PageComponentId["Notes"] = "notes.lazy-component";
    PageComponentId["PriceQuotes"] = "price-quotes";
    PageComponentId["Invoices"] = "invoices";
    PageComponentId["Checking"] = "wix-checking-bm-dashboard.pages.index";
    PageComponentId["RecurringInvoices"] = "CRM_FINANCIAL_RECURRING_INVOICES.pages.index";
    PageComponentId["RecurringInvoicesForm"] = "CRM_FINANCIAL_RECURRING_INVOICES.pages.form.index";
    PageComponentId["PartnersRecurringInvoicesForm"] = "CRM_FINANCIAL_RECURRING_INVOICES.pages.partners-form.index";
    PageComponentId["Integrations"] = "integrations";
    PageComponentId["InvoicesSettings"] = "invoices-settings";
    PageComponentId["Stores"] = "ecom";
    PageComponentId["StoresTax"] = "stores.tax";
    PageComponentId["StoresOrdersManager"] = "stores-orders-manager";
    PageComponentId["EcomGiftCards"] = "rise-client-dashboard.pages.index";
    PageComponentId["EcomGiftCardsManagment"] = "rise-client-dashboard.pages.gift-card-sales";
    PageComponentId["StoresFulfillmentServices"] = "stores-fulfillment-services";
    PageComponentId["StoresAbandonedCarts"] = "stores.abandoned-carts";
    PageComponentId["StoresProductList"] = "wixstores-dashboard-product-list.pages.index";
    PageComponentId["StoresSalesChannels"] = "stores.sales-channels";
    PageComponentId["StoresInkfrog"] = "stores.inkfrog";
    PageComponentId["StoresAmazon"] = "stores.amazon";
    PageComponentId["StoresWish"] = "STORES_CHANNELS_UI.pages.index";
    PageComponentId["StoresInventory"] = "wixstores-dashboard-inventory.pages.index";
    PageComponentId["StoresPos"] = "stores.pos";
    PageComponentId["StoresShipping"] = "stores.shipping";
    PageComponentId["StoresBackInStock"] = "WIXSTORES_DASHBOARD_BACK_IN_STOCK.pages.index";
    PageComponentId["StoresManualOrder"] = "wixstores-dashboard-create-manual-order-pages-index";
    PageComponentId["Shoutout"] = "shoutout";
    PageComponentId["ShoutoutCompliance"] = "shoutout-compliance";
    PageComponentId["PromoteSeo"] = "PromoteSeoLazyComponent";
    PageComponentId["Cashier"] = "cashier-merchant-settings";
    PageComponentId["CashierPaymentsDashboard"] = "cashier-payments-dashboard";
    PageComponentId["AppMarket"] = "app-market-lazy-page-component";
    PageComponentId["AppMarketMyApps"] = "app-market-my-apps-component";
    PageComponentId["Bookings"] = "bookings-lazy-module";
    PageComponentId["BookingsAppMarket"] = "bookings-integrations-channels-apps-page";
    PageComponentId["BookingsStaffList"] = "bookings-staff-list-lazy-component-id";
    PageComponentId["BookingsStaffDetails"] = "bookings-staff-details-lazy-component-id";
    PageComponentId["BookingsResourceTypesList"] = "1267cce6-9f18-4e32-9bcf-41860af3f52d";
    PageComponentId["BookingsResourceTypePage"] = "b1975f87-6249-42c3-8824-6fce45aa7c40";
    PageComponentId["BookingsBookingPolicyDetails"] = "bookings.bookings-policy-lazy";
    PageComponentId["BookingsPolicies"] = "bookings-policies-list";
    PageComponentId["BookingsPolicyFormPage"] = "bookings-policy-form-pages-policyid";
    PageComponentId["BookingsSessionDetails"] = "bookings-session-details-lazy-component-id";
    PageComponentId["BookingsCourseDetails"] = "bookings-course-details-lazy-component-id";
    PageComponentId["BookingsManageParticipants"] = "bookings-manage-participants-pages-manage-participants";
    PageComponentId["BookingsCalendar"] = "bookings-calendar-page-lazy-component-id";
    PageComponentId["BookingsFormSettingsPage"] = "bookings.bookings-form-page";
    PageComponentId["BookingsServicesList"] = "bookings-services-list-page";
    PageComponentId["BookingsServicePresetsGallery"] = "services-templates-root-component-id";
    PageComponentId["BookingsServiceForm"] = "bookings.bookings-service-form-lazy";
    PageComponentId["BookingsSettingsPage"] = "bookings.bookings-settings-page-lazy";
    PageComponentId["BookingsAvailabilitySlotsSettingsPage"] = "bookings-availability-slots-setting-page";
    PageComponentId["BookingsSiteDisplaySettingsPage"] = "bookings-site-display-setting-page";
    PageComponentId["BookingsMultiServiceSettingsPage"] = "bookings-multi-services-settings.pages.index";
    PageComponentId["BookingsNotifications"] = "bookings-email-sms-reminder-settings";
    PageComponentId["BookingsBookingsList"] = "3b9b5f2b-adc9-4099-80e6-5e74bc30e613";
    PageComponentId["BookingsIntegrationChannelsPage"] = "bookings-integrations-channels-page";
    PageComponentId["BookingsWorkSchedule"] = "bookings-availability-management-page-lazy-component-id";
    PageComponentId["BookingsBusinessDefaultHoursPage"] = "bookings-availability-management-pages-default-hours";
    PageComponentId["BookingsPageLinksDashboard"] = "3fd61c69-2a21-4b5a-936a-405d549dc335";
    PageComponentId["BookingsAnywhereSchedulingPage"] = "bookings-anywhere-scheduling-page-lazy-component-id";
    PageComponentId["DayfulAppMarket"] = "bookings-integration-channels-page-pages-dayfulappspage";
    PageComponentId["DayfulManageApps"] = "dayful-manage-apps.pages.index";
    PageComponentId["ContactBookings"] = "bookings.contact-bookings-lazy";
    PageComponentId["Contacts"] = "contacts-page-component";
    PageComponentId["ContactsSegments"] = "contacts-segments-page";
    PageComponentId["MemberPermissions"] = "member-permissions";
    PageComponentId["WixForms"] = "form-builder-component";
    PageComponentId["Seo"] = "seo-page-component";
    PageComponentId["SocialBlog"] = "social-blog";
    PageComponentId["Blog"] = "blog-page-component";
    PageComponentId["BlogCategories"] = "social-blog-categories";
    PageComponentId["BlogAnalytics"] = "social-blog-analytics";
    PageComponentId["BlogMonetization"] = "social-blog-monetization";
    PageComponentId["BlogTags"] = "social-blog-tags";
    PageComponentId["OldBlogUpdate"] = "old-blog-update";
    PageComponentId["Triggers"] = "triggers-page-component";
    PageComponentId["AutomationWizard"] = "triggers-wizard-page-component";
    PageComponentId["Example_React"] = "demo-react-lazy";
    PageComponentId["Example_Angular"] = "demo-angular-lazy";
    PageComponentId["Etpa_Container"] = "etpa-container-lazy-module";
    PageComponentId["Coupons"] = "coupons";
    PageComponentId["DiscountRules"] = "discount-rules.pages.index";
    PageComponentId["DiscountRule"] = "discount-rules.pages.rule.id";
    PageComponentId["DiscountNewRule"] = "discount-rules.pages.new-rule";
    PageComponentId["Restaurants"] = "restaurants";
    PageComponentId["CodeEmbed"] = "code-embed-lazy-page-component";
    PageComponentId["Events"] = "events";
    PageComponentId["MusicManagerMyAlbums"] = "music-manager.my-albums";
    PageComponentId["VideoLibrary"] = "video.video-library-lazy-page";
    PageComponentId["VideoMaker"] = "video-editor.videos";
    PageComponentId["PhotoAlbums"] = "photography-albums-id";
    PageComponentId["ArtStoreMain"] = "ART_STORE_MAIN";
    PageComponentId["ArtStoreChooseProvider"] = "ART_STORE_CHOOSE_PROVIDER_COMPONENT";
    PageComponentId["Multilingual"] = "multilingual-homepage";
    PageComponentId["MultilingualManageLanguages"] = "multilingual-manage-languages";
    PageComponentId["MultilingualSettings"] = "multilingual-pages-settings";
    PageComponentId["MultilingualPackagePicker"] = "multilingual-pages-package-picker";
    PageComponentId["MarketingIntegration"] = "MarketingIntegrationLazyComponent";
    PageComponentId["WixCodeDatabase"] = "wix-databases-lazy-page-component-id";
    PageComponentId["SiteCms"] = "site-cms";
    PageComponentId["SiteContent"] = "content-manager-site-content-app.pages.index";
    PageComponentId["WixPaymentsTransactions"] = "wix-payments-transactions";
    PageComponentId["WixPaymentsAccount"] = "wix-payments-account";
    PageComponentId["WixPaymentsPayouts"] = "wix-payments-payouts";
    PageComponentId["WixPaymentsPayables"] = "wix-payments-payables";
    PageComponentId["WixPaymentsTaxDocs"] = "wix-payments-tax-docs";
    PageComponentId["AdminPage"] = "admin-pages";
    PageComponentId["TasksWeb"] = "tasks-web";
    PageComponentId["TransactionalEmails"] = "transactional-emails";
    PageComponentId["TransactionalEmailsComposer"] = "transactional-emails-composer";
    PageComponentId["TeSmartActionsWidget"] = "te-smart-actions-widget";
    PageComponentId["Membership"] = "membership-lazy-component";
    PageComponentId["StaffManagement"] = "staff-management.pages.index";
    PageComponentId["MembershipSettings"] = "membership-settings-lazy-component";
    PageComponentId["BadgeDefinitions"] = "members-badges-bm-client-pages-index";
    PageComponentId["MembersAccountBm"] = "MEMBERS_ACCOUNT_BM.pages.index";
    PageComponentId["ShareitWeb"] = "share-it-web-lazy-component";
    PageComponentId["SocialMarketingWeb"] = "social-marketing-web";
    PageComponentId["PromotePublisher"] = "publish-social-post-page";
    PageComponentId["LogoBuilderLandingPage"] = "logo-builder-landing-page-lazy-component-id";
    PageComponentId["Workflow"] = "workflow-component";
    PageComponentId["Platforms101Workshop"] = "platforms-workshop-page-id";
    PageComponentId["PromoteHome"] = "PromoteHomeLazyComponent";
    PageComponentId["MyCampaigns"] = "ascend-pages.my-campaigns";
    PageComponentId["PingSettingsPageComponent"] = "ping-settings-lazy-page-component-id";
    PageComponentId["PingCustomerSettingsPageComponent"] = "ping-customer-notifications-lazy-page-component-id";
    PageComponentId["SiteSubscriptions"] = "site-subscriptions-lazy-component";
    PageComponentId["VideoMakerHome"] = "video-maker-home";
    PageComponentId["ReleaseManagerHome"] = "release-manager-client-lazy-component-id";
    PageComponentId["WixCodeSiteMonitoringSettings"] = "wix-code-site-monitoring-lazy-component-id";
    PageComponentId["WixCodeSecretsManagerHome"] = "wix-code-secrets-manager";
    PageComponentId["WixCodeSiteBranches"] = "wix-code-site-branches";
    PageComponentId["WixCodePlatformVisibilityHome"] = "wix-code-platform-visibility-bm.pages.index";
    PageComponentId["PromotePaidAds"] = "PromoteCampaignsLazyComponent";
    PageComponentId["PromoteGoogleAds"] = "pa-google-web.pages.index";
    PageComponentId["GoogleMyBusiness"] = "GoogleMyBusiness";
    PageComponentId["ContactsImport"] = "contacts-import-page";
    PageComponentId["ContactFullPage"] = "contact-full-page";
    PageComponentId["WixPhotoAlbumsMain"] = "albums-business-manager";
    PageComponentId["WixExpertsDashboardMain"] = "experts-dashboard-news";
    PageComponentId["WixExpertsDashboardBetas"] = "experts-dashboard-betas";
    PageComponentId["WixExpertsResources"] = "experts-resources";
    PageComponentId["WixPartnerDealsPageComponent"] = "partner-deals";
    PageComponentId["WixExpertsStudioHome"] = "experts-studio-home";
    PageComponentId["WixExpertsSettings"] = "experts-settings.pages.index";
    PageComponentId["WixExpertsProposals"] = "partner-proposals";
    PageComponentId["WixExpertsLoyaltyHome"] = "experts-loyalty-business-manager";
    PageComponentId["WixExpertsPartnerProgramEarnPoints"] = "experts-loyalty-ng.pages.earn-points";
    PageComponentId["WixExpertsPartnerProgramBenefits"] = "experts-loyalty-ng.pages.benefits";
    PageComponentId["WixExpertsPartnerProgramPointsHistory"] = "experts-loyalty-ng.pages.points-history";
    PageComponentId["WixExpertsPartnerProgramRevenueShare"] = "experts-loyalty-ng.pages.revenue-share";
    PageComponentId["WixExpertsPartnerProgramRevenueSharePaymentMethod"] = "experts-loyalty-ng.pages.payment-method";
    PageComponentId["WixExpertsPartnerProgramRevenueShareNG"] = "experts-rev-share.pages.index";
    PageComponentId["WixExpertsPartnerProgramRevenueSharePaymentMethodNG"] = "experts-rev-share.pages.payment-method";
    PageComponentId["AscendZeroStateInBizMgr"] = "ascend-zero-state-in-biz-mgr";
    PageComponentId["Analytics"] = "analytics.analytics-lazy-page";
    PageComponentId["AnalyticsStats"] = "analytics.analytics-stats-lazy-page";
    PageComponentId["AnalyticsReports"] = "analytics.analytics-reports-lazy-page";
    PageComponentId["PromoteSeoPatterns"] = "promote-seo-patterns";
    PageComponentId["PromoteSeoTools"] = "promote-seo-tools";
    PageComponentId["PromoteSeoHome"] = "promote-seo-home";
    PageComponentId["PrintShop"] = "print-shop-biz-mgr";
    PageComponentId["RicosPlayground"] = "RICOS_PLAYGROUND.pages.index";
    PageComponentId["MobileTab"] = "mobile_tab_bm";
    PageComponentId["MobileTabNew"] = "new-mobile-tab";
    PageComponentId["SocialGroupsDashboard"] = "social-groups-dashboard";
    PageComponentId["MarketplaceContainer"] = "app-market-lazy-page-component";
    PageComponentId["RestaurantsCallCenter"] = "restaurants-call-center";
    PageComponentId["VirtualNumbers"] = "virtual-numbers";
    PageComponentId["SMS"] = "sms-bm.pages.index";
    PageComponentId["SMSManage"] = "sms-bm.pages.manage";
    PageComponentId["SMSNumber"] = "sms-bm.pages.number";
    PageComponentId["SMSPurchase"] = "sms-bm.pages.purchase";
    PageComponentId["Forum"] = "communities-forum";
    PageComponentId["ForumSettings"] = "communities-forum-settings";
    PageComponentId["ForumCategories"] = "communities-forum-categories";
    PageComponentId["RolesAndPermissions"] = "site-roles-and-permissions";
    PageComponentId["WixPartnersTeam"] = "partners-team";
    PageComponentId["CoBranding"] = "co-branding";
    PageComponentId["Subscriptions"] = "subscriptions-bm";
    PageComponentId["StoresExploreProducts"] = "stores-explore-products";
    PageComponentId["Arena"] = "arena-biz-manager";
    PageComponentId["ManageInstalledApps"] = "app-market-my-apps-component";
    PageComponentId["AnalyticsNgBm"] = "analytics-ng-bm";
    PageComponentId["AnalyticsNgTools"] = "analytics-ng-tools";
    PageComponentId["AnalyticsNgPerformance"] = "analytics-ng-performance";
    PageComponentId["AnalyticsNgPerformanceInsights"] = "analytics-ng-performance-analytics-ng-insights";
    PageComponentId["AnalyticsNgCustomReports"] = "analytics-ng-custom-reports";
    PageComponentId["AnalyticsNgNativeOverviews"] = "analytics-ng-native-overviews";
    PageComponentId["AnalyticsNgNativeOverviewsBehavior"] = "analytics-ng-bm.pages.overviews.behavior";
    PageComponentId["AnalyticsNgNativeOverviewsMarketing"] = "analytics-ng-bm.pages.overviews.marketing";
    PageComponentId["AnalyticsNgNativeOverviewsRealtime"] = "analytics-ng-bm.pages.overviews.realtime";
    PageComponentId["AnalyticsNgNativeOverviewsBlog"] = "analytics-ng-bm.pages.overviews.blog";
    PageComponentId["SiteHistory"] = "site-history-client";
    PageComponentId["RestaurantsSocialBar"] = "restaurants_social_bar";
    PageComponentId["RestaurantsReservations"] = "restaurants_reservations";
    PageComponentId["RestaurantsOrders"] = "restaurants_orders";
    PageComponentId["RestaurantsOnlineOrdering"] = "restaurants_online_ordering";
    PageComponentId["RestaurantsOrdersPrepBoard"] = "restaurants-orders-prep-board.pages.index";
    PageComponentId["RestaurantsIntegrations"] = "restaurants-integrations";
    PageComponentId["RestaurantsReservationsSettings"] = "restaurants-reservations-settings-v2";
    PageComponentId["RestaurantsTableReservations"] = "table-reservations-bm-pages-table-reservations";
    PageComponentId["RestaurantsTableReservationsSettings"] = "table-reservations-bm-pages-table-reservations-settings";
    PageComponentId["RestaurantsTableReservationsAdvancedSettings"] = "table-reservations-bm-pages-advanced-settings";
    PageComponentId["RestaurantsMarketplace"] = "restaurants-marketplace-bm.pages.index";
    PageComponentId["RestaurantsMenusShowcase"] = "restaurants-menus-showcase";
    PageComponentId["RestaurantsMenusItemsManagement"] = "restaurants-menus-management-items";
    PageComponentId["CookieConsentBannerSettings"] = "cookie-consent-settings-app";
    PageComponentId["ConsentLog"] = "consent-log-page";
    PageComponentId["CrmHome"] = "crm-home";
    PageComponentId["FedataIndex"] = "yoshi-flow-bm-demo.pages.index";
    PageComponentId["SettingsLobby"] = "settings-lobby";
    PageComponentId["FedataContacts"] = "yoshi-flow-bm-demo.pages.contacts";
    PageComponentId["LanguageAndRegion"] = "language-and-region-lazy";
    PageComponentId["WebsiteSettings"] = "website-settings-lazy";
    PageComponentId["BusinessInfo"] = "business-info-lazy";
    PageComponentId["LiveVideo"] = "LIVE_VIDEO.pages.index";
    PageComponentId["PartnersPackage"] = "partners-package-lazy-component";
    PageComponentId["Loyalty"] = "loyalty-bm-pages-index";
    PageComponentId["LoyaltyManage"] = "loyalty-bm-pages-manage";
    PageComponentId["LoyaltyWizard"] = "loyalty-bm-pages-wizard";
    PageComponentId["LoyaltyEmailAutomations"] = "loyalty-bm-pages-email-automations";
    PageComponentId["Referrals"] = "referrals-bm.pages.index";
    PageComponentId["FAQPage"] = "faq-page-bm.pages.index";
    PageComponentId["AdsensePage"] = "adsense-bm.pages.index";
    PageComponentId["PromotionsPage"] = "promotions-bm.pages.index";
    PageComponentId["MyMailboxes"] = "MY_MAILBOXES_SITE_LEVEL.pages.index";
    PageComponentId["BrandedApps"] = "BRANDED_APPS.pages.welcome";
    PageComponentId["WebsiteChannel"] = "website-channel-page";
    PageComponentId["NewMobileTab"] = "new-mobile-tab.pages.index";
    PageComponentId["MyDomains"] = "MY_DOMAINS_IFRAME_WRAPPER.pages.index";
    PageComponentId["SsoSettings"] = "sso-settings-client.pages.index";
    PageComponentId["DinersModeration"] = "diners-moderation-bm.pages.index";
    PageComponentId["DinersModerationDetails"] = "diners-moderation-bm.pages.details";
    PageComponentId["DiscoveryModeration"] = "discovery-moderation-bm.pages.index";
    PageComponentId["DiscoveryModerationDetails"] = "discovery-moderation-bm.pages.details";
    PageComponentId["Portfolio"] = "portfolio.pages.index";
    PageComponentId["Reviews"] = "wix-reviews.pages.index";
    PageComponentId["SitesList"] = "sites-list-client";
    PageComponentId["ApesPmFlow"] = "crm-automations-apes-pm-flow.pages.index";
    PageComponentId["WixAnywhereWebsiteWidgets"] = "wix-anywhere-bm.widgets-list";
    PageComponentId["WixAnywhereEditDesign"] = "wix-anywhere-bm.edit-design";
    PageComponentId["MembersAreaSettings"] = "members-area-settings-bm.pages.index";
    PageComponentId["MemberPrivacySettings"] = "member-privacy-bm-pages-member-privacy";
    PageComponentId["WixComments"] = "comments-widget-bm.pages.index";
    PageComponentId["TikTokCatalog"] = "tiktok-catalog-app.pages.index";
    PageComponentId["SitesListV2"] = "9d314f0f-446c-4787-b3ca-680e70237d1f";
    PageComponentId["GoogleForMerchants"] = "stores-channels-google.pages.index";
    PageComponentId["BrandMaker"] = "brand-maker-biz-mgr";
    PageComponentId["OAuthAppsSettings"] = "oauth-apps-settings.pages.index";
    PageComponentId["Donations"] = "wix-donations-dashboard.pages.index";
    PageComponentId["EcommerceApps"] = "wixstores-dashboard-exports.pages.ecom-apps";
    PageComponentId["PayLinks"] = "payment-links-bm.pages.index";
    PageComponentId["Pos"] = "pos-bm.pages.index";
    PageComponentId["PosSettings"] = "pos-bm-pages-settings";
    PageComponentId["PosTimeCardReport"] = "pos-bm.pages.time-card-report";
    PageComponentId["PosRegisterReport"] = "pos-bm.pages.register-report";
    PageComponentId["PosRegisterHistory"] = "pos-bm.pages.register-history";
    PageComponentId["PosOnboarding"] = "pos-onboarding.pages.index";
    PageComponentId["PosUpgrade"] = "pos-onboarding.pages.upgrade";
    PageComponentId["HeadlessApps"] = "headless-manage-apps.pages.index";
    PageComponentId["Community"] = "community-pages-index";
    PageComponentId["MobileAppDashboard"] = "mobile-app.pages.dashboard";
    PageComponentId["Tips"] = "wix-tips-dashboard.pages.index";
    // ** deprecated - do not use this enum. use hardcoded IDs **
    // ....................................................................................
    // ......SSSSSSSSS......TTTTTTTTTTTTTTTTTTT......OOOOOOOOOO........PPPPPPPPPPPP........
    // ....SSSSSSSSSSSSS...STTTTTTTTTTTTTTTTTTT....OOOOOOOOOOOOO......PPPPPPPPPPPPPPPP.....
    // ...SSSSSSSSSSSSSSS..STTTTTTTTTTTTTTTTTTT...OOOOOOOOOOOOOOOO....PPPPPPPPPPPPPPPPP....
    // ...SSSSSSSSSSSSSSSS.STTTTTTTTTTTTTTTTTTT..OOOOOOOOOOOOOOOOOO...PPPPPPPPPPPPPPPPPP...
    // ..SSSSSSSSSSSSSSSSSSSTTTTTTTTTTTTTTTTTTT.OOOOOOOOOOOOOOOOOOO...PPPPPPPPPPPPPPPPPP...
    // ..SSSSSSS....SSSSSSS.TTTTTTTTTTTTTTTTTTTOOOOOOOOO...OOOOOOOOO..PPPPPPPPPPPPPPPPPPP..
    // ..SSSSSS......SSSSSS.......TTTTTTT......OOOOOOO.......OOOOOOO..PPPPPPP.....PPPPPPP..
    // ..SSSSSS......SSSSSS.......TTTTTTT......OOOOOOO.......OOOOOOOO.PPPPPPP.....PPPPPPP..
    // ..SSSSSSSS.................TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPP.....PPPPPPP..
    // ..SSSSSSSSSSSS.............TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPP.....PPPPPPP..
    // ..SSSSSSSSSSSSSSS..........TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPPPPPPPPPPPPPP..
    // ...SSSSSSSSSSSSSSSS........TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPPPPPPPPPPPPPP..
    // ....SSSSSSSSSSSSSSSS.......TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPPPPPPPPPPPPP...
    // ......SSSSSSSSSSSSSSS......TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPPPPPPPPPPPP....
    // ..........SSSSSSSSSSS......TTTTTTT.....TOOOOOO.........OOOOOOO.PPPPPPPPPPPPPPPP.....
    // ..SSSSS.......SSSSSSS......TTTTTTT......OOOOOO.........OOOOOOO.PPPPPPPPPPPPPP.......
    // .SSSSSSS.......SSSSSS......TTTTTTT......OOOOOOO.......OOOOOOOO.PPPPPPP..............
    // .SSSSSSS......SSSSSSS......TTTTTTT......OOOOOOOO.....OOOOOOOO..PPPPPPP..............
    // .SSSSSSSS....SSSSSSSS......TTTTTTT.......OOOOOOOO...OOOOOOOOO..PPPPPPP..............
    // ..SSSSSSSSSSSSSSSSSS.......TTTTTTT.......OOOOOOOOOOOOOOOOOOO...PPPPPPP..............
    // ...SSSSSSSSSSSSSSSSS.......TTTTTTT........OOOOOOOOOOOOOOOOO....PPPPPPP..............
    // ...SSSSSSSSSSSSSSSS........TTTTTTT.........OOOOOOOOOOOOOOO.....PPPPPPP..............
    // .....SSSSSSSSSSSSS.........TTTTTTT..........OOOOOOOOOOOOO......PPPPPPP..............
    // .......SSSSSSSSS..............................OOOOOOOOO.............................
    // ....................................................................................
})(PageComponentId || (PageComponentId = {}));
//# sourceMappingURL=PageComponentId.js.map